// packages/ui/src/primitives/forms/ContactHoneypot.tsx
// Uncontrolled and outside the tab order/accessibility tree. Inline styles survive host themes.
import type { Ref } from 'react';

export function ContactHoneypot({ inputRef }: { inputRef?: Ref<HTMLInputElement> }) {
  return (
    <div aria-hidden="true" style={{ position: 'absolute', width: 1, height: 1, overflow: 'hidden', clipPath: 'inset(50%)', pointerEvents: 'none' }}>
      <label>
        Company website
        <input ref={inputRef} name="companyWebsite" type="text" tabIndex={-1} autoComplete="off" maxLength={2000} />
      </label>
    </div>
  );
}
